export enum BUTTON_STYLE {
    PRIMARY = 'primary',
    SECONDARY = 'secondary',
    SECONDARY_LIGHT = 'secondary_light',
    LINK = 'link',
    LINK_LIGHT = 'link_light'
}

